export const formatChangeValue = (value: number) => {
    const positiveValue = Math.abs(value);

    return `${(positiveValue * 100).toFixed(2)}pp`;
};
